// Admin API client — uses separate admin token from user token
const BASE_URL = process.env.REACT_APP_BACKEND_URL;

export function getAdminToken() { return localStorage.getItem('admin_token'); }
export function setAdminToken(t) { localStorage.setItem('admin_token', t); }
export function clearAdminToken() { localStorage.removeItem('admin_token'); }

export async function adminApi(path, options = {}) {
  const token = getAdminToken();
  const headers = { 'Content-Type': 'application/json', ...(options.headers || {}) };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  const res = await fetch(`${BASE_URL}/api${path}`, { ...options, headers });
  if (!res.ok) {
    let err;
    try { err = await res.json(); } catch { err = { detail: `HTTP ${res.status}` }; }
    const detail = err.detail;
    const message = typeof detail === 'object' ? JSON.stringify(detail) : (detail || `HTTP ${res.status}`);
    const e = new Error(message);
    e.detail = detail;
    e.status = res.status;
    throw e;
  }
  const text = await res.text();
  return text ? JSON.parse(text) : null;
}
